<div bsModal
     #smModal="bs-modal"
     class="modal fade pleaseWaitDialog"
     [config]="{backdrop: true, ignoreBackdropClick: true}"
     (onEsc)="close()"
     (onHidden)="onHidden.emit()"
     tabindex="-1"
     role="dialog"
     aria-labelledby="mySmallModalLabel"
     aria-hidden="true">
    <div class="modal-dialog {{getSizeClass()}}">
        <div class="modal-content" [ngClass]="{'warning': publish}">
            <div class="container-fluid">
                <div class="row py-3 modal-header">
                    <div class="{{getHeaderSizeClass('title')}} px-0">
                        <h2 class="modal-title"
                        *ngIf="headerText">{{headerText | translate}}</h2>
                    </div>
                    <div class="{{getHeaderSizeClass('todo')}} py-1 text-center">
                        <i *ngIf="showClose"
                            class="far fa-times close-icon"
                            (click)="headerText == 'Download' ? cancel() : close()"></i>
                    </div>
                </div>
            </div>
            <ng-content></ng-content>
        </div>
    </div>
</div>